import { createAction } from "@reduxjs/toolkit";
import {
  verificationActionTypes,
  resendVerificationLinkActionTypes,
  verificationPasswordCodeActionTypes,
  confirmEmailChangeActionTypes,
} from "./actionTypes";

export const resendVerificationLink = createAction(
  resendVerificationLinkActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const resendVerificationLinkSuccess = createAction(
  resendVerificationLinkActionTypes.success,
  (payload) => ({
    payload,
  }),
);

export const resendVerificationLinkFailure = createAction(
  resendVerificationLinkActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

export const verification = createAction(
  verificationActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const verificationSuccess = createAction(
  verificationActionTypes.success,
  (payload) => ({
    payload,
  }),
);

export const verificationFailure = createAction(
  verificationActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

export const verificationReset = createAction(verificationActionTypes.reset);

export const verificationPasswordCode = createAction(
  verificationPasswordCodeActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const verificationPasswordCodeSuccess = createAction(
  verificationPasswordCodeActionTypes.success,
  (payload) => ({
    payload,
  }),
);

export const verificationPasswordCodeFailure = createAction(
  verificationPasswordCodeActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

export const confirmEmailChange = createAction(
  confirmEmailChangeActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const confirmEmailChangeSuccess = createAction(
  confirmEmailChangeActionTypes.success,
  (payload) => ({
    payload,
  }),
);

export const confirmEmailChangeFailure = createAction(
  confirmEmailChangeActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);
